import { ReportSummaryConfigBase } from "../../summary/types";

export const Summary: ReportSummaryConfigBase[] = [
  {
    label: "Number of Reps",
    fields: ["row_count"],
    type: ["COUNT"],
  },
  {
    label: "Total Change",
    fields: ["total_change"],
    type: ["MONEY"],
  },
  {
    label: "Current Period Invoices",
    fields: ["start_stamp_curr", "end_stamp_curr"],
    type: ["HIDDEN", "HIDDEN"],
  },
  {
    label: "Previous Period Invoices",
    fields: ["start_stamp_prev", "end_stamp_prev"],
    type: ["HIDDEN", "HIDDEN"],
  },
];
